import { Skeleton } from "@dafiti/closet-ui";
import { cn } from "@dafiti/closet-ui/utils";

/** Mobile skeleton for the QuickFilters bar */
function MobileSkeleton() {
  return (
    <div className="flex flex-col gap-2 lg:hidden">
      {/* Row 1: MoreFilters + Sort + QuickFilters */}
      <div className="flex items-center">
        <Skeleton className="size-xs mr-4 rounded-full" />
        <Skeleton className="size-xs rounded-full" />

        <div className="w-px h-8 ml-4 mr-2 bg-gray-200 mx-nano" />

        <div className="flex gap-2">
          <Skeleton className="h-2xs w-[72px] rounded-lg" />
          <Skeleton className="h-2xs w-[56px] rounded-lg" />
          <Skeleton className="h-2xs w-[64px] rounded-lg" />
        </div>
      </div>

      {/* Divider */}
      <div className="w-full h-px mb-2 bg-gray-200" />

      {/* Row 2: Boolean pills */}
      <div className="flex items-center gap-2">
        <Skeleton className="h-2xs w-[120px] rounded-full" />
        <Skeleton className="h-2xs w-[120px] rounded-full" />
      </div>
    </div>
  );
}

/** Desktop skeleton for the QuickFilters bar — mirrors the CSS Grid of QuickFiltersBar */
function DesktopSkeleton() {
  return (
    <div
      className={cn(
        "hidden lg:grid items-center lg:gap-y-4",
        "lg:grid-cols-[1fr_auto]",
        "lg:[grid-template-areas:'booleans_sorting''list_list']",
        "xl:[grid-template-areas:'booleans_booleans''list_sorting']",
      )}
    >
      {/* Row 1 (lg) / Row 1 (xl): Boolean switches */}
      <div className="[grid-area:booleans] flex items-center gap-3xs">
        <Skeleton className="h-6 w-[140px] rounded-lg" />
        <Skeleton className="h-6 w-[140px] rounded-lg" />
      </div>

      {/* Row 1 col-right (lg) / Row 2 col-right (xl): Sort */}
      <div className="[grid-area:sorting] flex items-center lg:justify-self-end">
        <Skeleton className="h-10.5 w-[140px] rounded-lg" />
      </div>

      {/* Row 2 (lg+xl): QuickFilters + MoreFilters */}
      <div className="[grid-area:list] flex items-center gap-nano">
        <Skeleton className="h-10 w-[100px] rounded-lg" />
        <Skeleton className="h-10 w-[80px] rounded-lg" />
        <Skeleton className="h-10 w-[72px] rounded-lg" />
        <Skeleton className="h-10 w-[64px] rounded-lg" />
        <Skeleton className="h-10 w-[100px] rounded-lg" />
        <Skeleton className="h-10 w-[80px] rounded-lg" />
      </div>
    </div>
  );
}

export function QuickFiltersBarSkeleton() {
  return (
    <div data-testid="quick-filters-bar-skeleton">
      <MobileSkeleton />
      <DesktopSkeleton />
    </div>
  );
}
